import type { Animal } from './animal.interface';

export interface cv_Sex {
    Abbreviation: string;
    Animal: Animal[];
    C_Sex_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    Sex: string;
    SortOrder: number | null;
    Version: number;
}
